module.exports = __webpack_public_path__ + "img/7.bad_smell.05adf906.svg";